import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

const VAULT_ARROW_COLOR = '#3E7BDA';

export enum VaultFolderIconVariant {
  COMPACT,
  REGULAR,
}

export type VaultFolderIconProps = {
  variant?: VaultFolderIconVariant;
} & IconProps;

const CompactVaultFolderIcon: FC<IconProps> = ({
  iconColor = '#475467',
  className,
  height = 13,
  width = 13,
  ...props
}) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height={height}
    viewBox="0 0 13 13"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.71121 9.76628H1.82232C1.49817 9.76628 1.18729 9.63751 0.958078 9.4083C0.728867 9.17908 0.600098 8.86821 0.600098 8.54405V1.82183C0.600098 1.49768 0.728867 1.1868 0.958078 0.95759C1.18729 0.728379 1.49817 0.599609 1.82232 0.599609H4.26676L6.1001 2.43294H10.3779C10.702 2.43294 11.0129 2.56171 11.2421 2.79092C11.4713 3.02013 11.6001 3.33101 11.6001 3.65516V5.79405"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.2"
    />
    <path
      d="M10.378 7.93359L9.15576 9.76693H11.6002L10.378 11.6003"
      stroke={VAULT_ARROW_COLOR}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.2"
    />
  </svg>
);

const RegularVaultFolderIcon: FC<IconProps> = ({
  iconColor = '#475467',
  className,
  height = 32,
  width = 32,
  ...props
}) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height={height}
    viewBox="0 0 32 32"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.2222 24.6654H7.44444C6.79614 24.6654 6.17438 24.4078 5.71596 23.9494C5.25754 23.491 5 22.8692 5 22.2209V8.77648C5 8.12817 5.25754 7.50641 5.71596 7.04799C6.17438 6.58957 6.79614 6.33203 7.44444 6.33203H12.3333L16 9.9987H24.5556C25.2039 9.9987 25.8256 10.2562 26.284 10.7147C26.7425 11.1731 27 11.7948 27 12.4431V16.7209"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M24.5555 20.998L22.1111 24.6647H27L24.5555 28.3314"
      stroke={VAULT_ARROW_COLOR}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export const VaultFolderIcon: FC<VaultFolderIconProps> = ({
  variant = VaultFolderIconVariant.REGULAR,
  ...props
}) =>
  variant === VaultFolderIconVariant.COMPACT ? (
    <CompactVaultFolderIcon {...props} />
  ) : (
    <RegularVaultFolderIcon {...props} />
  );
